<template>
  <div class="VideoRecommend">
      <p class="name">直播推荐</p>
      <div class="Video-recommend-list">
          <div class="video-recommend-item" v-for="(item, index) in recommendList" :key="index" @click="goto(item.innerid)">
              <div class="img"><img class="video-img" v-lazy="item.coverurl" :alt="item.subject"></div>
              <p>{{item.subject}}</p>
          </div>
      </div>
  </div>
  <!-- end 视频推荐 -->
</template>

<script>
import {getIndexList} from 'api/web-app.js'
import { mapActions } from 'vuex'
export default {
  name: 'VideoRecommend',
  data () {
    return {
        recommendList: []  // 推荐列表
    }
  },
  mounted () {
      this.init()
  },
  methods: {
      goto(innerid) {  // 页面跳转
        const {href} = this.$router.resolve({
            name: "VideoLiveing",
            query: {innerid: innerid, chid: this.$route.query.chid ? this.$route.query.chid : ''}
        })
        window.open(href, '_blank')
      },
      init() {  // 初始化直播
        this.setLoading(true)
        getIndexList({
            data: {datacount: 5},
            success: data => {
                this.setLoading(false)
                this.recommendList = data.data
            },
            error: data => {
                this.setLoading(false)
                this.$message.error(data.msg)
            }
        })
      },
      ...mapActions(['setLoading'])
  },
  filters: {},
  watch: {},
  computed: {},
  components: {
  }
}
</script>

<style lang="scss" type="text/scss" scoped>
.VideoRecommend {
    margin-left: 20px;
    width:300px;
    padding: 20px;
    box-sizing: border-box;
    background:rgba(255,255,255,1);
    border-radius:16px;
    .name {
        font-size: 18px;
    }
    
    .video-recommend-item {
        margin-top: 20px;
        cursor: pointer;
        .img {
            width:260px;
            height:146px;
            border-radius: 8px;
            overflow: hidden;
            background: #ccc;

            img {
                width: 100%;
                height: 100%;
                transition: all .5s;
                -webkit-transition: all .5s;
                -ms-transition: all .5s;
                -moz-transition: all .5s;
                -o-transition: all .5s;
                border-radius: 8px;

                &:hover {
                    transition: all .5s;
                    -webkit-transition: all .5s;
                    -ms-transition: all .5s;
                    -moz-transition: all .5s;
                    -o-transition: all .5s;
                    transform: scale(1.2);
                    -webkit-transform: scale(1.2);
                    -ms-transform: scale(1.2);
                    -moz-transform: scale(1.2);
                    -o-transform: scale(1.2);
                }
            }
        }
        p {
            margin-top: 12px;
            font-size: 14px;
            max-height: 40px;
            line-height: 1.3;
            text-overflow: ellipsis;
            -webkit-text-overflow: ellipsis;
            -ms-text-overflow: ellipsis;
            -o-text-overflow: ellipsis;
            overflow: hidden;
            line-clamp: 2;
            -webkit-line-clamp: 2;
            -webkit-box-orient: vertical;
            display: -webkit-box;
            &:hover {
                color: #409EFF;
            }
        }
    }
}
</style>